export interface ShippingAddressFormData {
  country: string;
  fullName: string;
  address: string;
  unit: string;
}

export interface ShippingAddress extends ShippingAddressFormData {
  googlePlaceId: string;
}

export const EMPTY_SHIPPING_ADDRESS: ShippingAddress = {
  country: '',
  fullName: '',
  address: '',
  unit: '',
  googlePlaceId: '',
};



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/transaction/shipping/shipping-address.ts